<template>
  <div>
    <b-button
      v-permission="'subscription_plans.create'"
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      @click="addNew">
      <feather-icon
        icon="PlusIcon"
        class="mr-50"/>
      <span class="align-middle">{{ $t('AddNew') }}</span>
    </b-button>

    <Grid
      :service="service"
      route_name="subscription_plans"
      order_column="name">
      <template v-slot:gridThead>
        <vs-th key="id" sort-key="id">{{ $t('subscription_plan.id') }}</vs-th>
        <vs-th key="name" sort-key="name">{{ $t('subscription_plan.name') }}</vs-th>
        <vs-th key="status" sort-key="status">{{ $t('subscription_plan.status') }}</vs-th>
        <vs-th key="description" sort-key="description">{{ $t('subscription_plan.description') }}</vs-th>
        <vs-th key="interval" sort-key="interval">{{ $t('subscription_plan.interval') }}</vs-th>
        <!-- Sem coluna de preço próprio: o preço mora no anúncio (produto) e
             aparece na coluna "Venda" ao lado. -->
        <vs-th key="billing_cycles" sort-key="billing_cycles">{{ $t('subscription_plan.billing_cycles') }}</vs-th>
        <vs-th key="sale">{{ $t('catalog.listing.column') }}</vs-th>
      </template>
      <template v-slot:gridData="props">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in props.data">
          <vs-td width="5%" key="id">
            <div> {{ tr.id }} </div>
          </vs-td>
          <vs-td width="22%" key="name">
            <div class="font-medium">{{ tr.name }}</div>
          </vs-td>
          <vs-td width="10%" key="status">
            <vs-chip transparent :color="getStatusColor(tr.status)" class="text-base">{{ tr.status_label }}</vs-chip>
          </vs-td>
          <vs-td width="30%" key="description">
            <div v-html-safe="tr.description"></div>
          </vs-td>
          <vs-td width="12%" key="interval">
            <vs-chip transparent :color="getIntervalColor(tr.interval)" class="text-base">{{ tr.interval_label }}</vs-chip>
          </vs-td>
          <vs-td width="8%" key="billing_cycles">
            <span>{{ tr.billing_cycles != null ? tr.billing_cycles : $t('subscription_plan.billing_unlimited') }}</span>
          </vs-td>
          <vs-td width="13%" key="sale">
            <div class="flex flex-row gap-2 items-center">
              <sale-status-badge :sale="saleMap[tr.id]"/>
              <feather-icon
                v-if="!isPublished(tr.id)"
                v-permission="'subscription_plans.edit'"
                icon="PlayCircleIcon"
                class="h-5 w-5 stroke-current text-primary cursor-pointer"
                v-tooltip="$t('catalog.listing.resume')"
                @click="resumeSale(tr.id)"/>
              <a
                v-else-if="listingUrl(tr.id)"
                :href="listingUrl(tr.id)"
                target="_blank"
                rel="noopener"
                v-tooltip="$t('catalog.listing.see')">
                <feather-icon icon="ExternalLinkIcon" class="h-5 w-5 stroke-current text-success"/>
              </a>
            </div>
          </vs-td>
          <vs-td width="10%">
            <div class="flex flex-row gap-2 items-center">
              <feather-icon
                v-permission="'subscription_plans.edit'"
                icon="EditIcon"
                class="h-5 w-5 stroke-current text-warning cursor-pointer"
                v-tooltip="$t('action.edit')"
                @click="props.edit(props.data[indextr].id)"/>
              <feather-icon
                v-permission="'subscription_plans.delete'"
                icon="Trash2Icon"
                class="h-5 w-5 stroke-current text-danger cursor-pointer"
                v-tooltip="$t('action.delete')"
                @click="props.destroy(props.data[indextr])"/>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </Grid>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

import SubscriptionPlanService from '@/services/api/SubscriptionPlanService'
import ProductService from '@/services/api/ProductService'
import SaleStatusBadge from '@/components/catalog/SaleStatusBadge.vue'
import { marketplaceItemUrl } from '@/components/catalog/catalog'

export default {
  directives: {
    Ripple,
  },
  components: {
    BButton,
    SaleStatusBadge
  },
  data: () => ({
    selected: [],
    service: null,
    /** plano id → linha do mapa item→produto (situação de venda). */
    saleMap: {}
  }),
  methods: {
    addNew() {
      this.$router.push('/subscription_plans/create')
    },
    resumeSale(id) {
      this.$router.push(`/subscription_plans/${id}/edit?step=venda`)
    },
    isPublished(id) {
      const sale = this.saleMap[id]
      return !!sale && sale.status === 'RE'
    },
    listingUrl(id) {
      const sale = this.saleMap[id]
      return sale ? marketplaceItemUrl('SPL', sale.product_id) : null
    },
    loadSaleMap() {
      ProductService.build(this.$vs).getItemsMap('SPL').then(rows => {
        const map = {}
        ;(Array.isArray(rows) ? rows : []).forEach(row => {
          if (!map[row.model_id] || row.status === 'RE') {
            map[row.model_id] = row
          }
        })
        this.saleMap = map
      }).catch(() => {})
    },
    getIntervalColor(interval) {
      const colorMap = {
        weekly: 'primary',
        biweekly: 'primary',
        monthly: 'success',
        bimonthly: 'success',
        semiannual: 'warning',
        annual: 'warning'
      }
      return colorMap[interval] || 'default'
    },
    getStatusColor(status) {
      return status === 'AC' ? 'success' : 'secondary'
    }
  },
  beforeMount() {
    this.service = SubscriptionPlanService.build(this.$vs)
  },
  mounted() {
    this.loadSaleMap()
  }
}
</script>
